'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PagerButtons = function (_Component) {
  (0, _inherits3.default)(PagerButtons, _Component);

  function PagerButtons() {
    (0, _classCallCheck3.default)(this, PagerButtons);
    return (0, _possibleConstructorReturn3.default)(this, (PagerButtons.__proto__ || (0, _getPrototypeOf2.default)(PagerButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(PagerButtons, [{
    key: 'handleBack',
    value: function handleBack() {
      if (!this.props.isBackDisabled) {
        this.props.onBack();
      }
    }
  }, {
    key: 'handleNext',
    value: function handleNext() {
      if (!this.props.isNextDisabled) {
        this.props.onNext();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: this.containerClass
      }, _react2.default.createElement('div', {
        className: this.backButtonClass,
        onClick: this.handleBack.bind(this)
      }, _react2.default.createElement('i', {
        className: 'PagerButtons-button-icon material-icons'
      }, "\uE314"), 'Back'), this.nextButtonContent);
    }
  }, {
    key: 'containerClass',
    get: function get() {
      var classes = 'PagerButtons';

      if (this.props.className) {
        classes += ' ' + this.props.className;
      }

      return classes;
    }
  }, {
    key: 'backButtonClass',
    get: function get() {
      var classes = 'PagerButtons-button PagerButtons-button--back';

      if (this.props.isBackDisabled) {
        classes += ' is-disabled';
      }

      return classes;
    }
  }, {
    key: 'nextButtonClass',
    get: function get() {
      var classes = 'PagerButtons-button PagerButtons-button--next';

      if (this.props.isNextDisabled) {
        classes += ' is-disabled';
      }

      if (this.props.isInProgress) {
        classes += ' is-inProgress';
      }

      return classes;
    }
  }, {
    key: 'nextButtonContent',
    get: function get() {
      if (this.props.isInProgress) {
        return _react2.default.createElement('div', {
          className: this.nextButtonClass
        }, _react2.default.createElement('span', {
          className: 'PagerButtons-spinner'
        }));
      } else {
        return _react2.default.createElement('div', {
          className: this.nextButtonClass,
          onClick: this.handleNext.bind(this)
        }, 'Next', _react2.default.createElement('i', {
          className: 'PagerButtons-button-icon material-icons'
        }, "\uE315"));
      }
    }
  }]);
  return PagerButtons;
}(_react.Component);

PagerButtons.propTypes = {
  onNext: _propTypes2.default.func,
  onBack: _propTypes2.default.func,
  isNextDisabled: _propTypes2.default.bool,
  isBackDisabled: _propTypes2.default.bool,
  isInProgress: _propTypes2.default.bool
};
PagerButtons.defaultProps = {
  onNext: function onNext() {},
  onBack: function onBack() {},
  isNextDisabled: false,
  isBackDisabled: false,
  isInProgress: false
};
exports.default = PagerButtons;